import { GuestRoute } from '@dealstack/frontend/shared/pages/GuestRoute/GuestRoute';
import {
	DEFAULT_PROTECTED_ROUTE,
	GODMODE_ROOT_ROUTES,
} from '@dealstack/frontend/admin/pages/Routing/Routing';
import { Navigate, Route } from 'react-router-dom';
import { AuthLayoutV2 } from '@dealstack/frontend/shared/layout/AuthLayout/AuthLayoutV2';
import { AuthStart } from '@dealstack/frontend/shared/pages/AuthStart/AuthStart';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';
import { ApplicationType } from '@dealstack/shared/lib/generated';

interface Props {
	className?: string;
	applicationType: ApplicationType;
}

export enum AUTH_ROUTES {
	LOGIN = '/login',
	GENERIC_ERROR = '/error',
}

export const Auth = ({ className, applicationType }: Props) => {
	return (
		<div className={className}>
			<AuthLayoutV2>
				<GuestRoute defaultProtectedRoute={DEFAULT_PROTECTED_ROUTE}>
					<SentryRoutes>
						<Route
							path={AUTH_ROUTES.LOGIN}
							element={<AuthStart applicationType={applicationType} />}
						/>
						<Route
							path="*"
							element={
								<Navigate to={`${GODMODE_ROOT_ROUTES.AUTH}${AUTH_ROUTES.LOGIN}`} />
							}
						/>
					</SentryRoutes>
				</GuestRoute>
			</AuthLayoutV2>
		</div>
	);
};
